$(document).ready(function(){
  new KTImageInput('kt_image_input');
});